import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter } from "react-router-dom";
import axios from "axios";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import { store } from "./components/redux/store/dataStore";
import { persistor } from "./components/redux/store/dataStore";
import { RemoveUser } from "./components/redux/Actions/UserActions";
import { RemoveMuseum } from "./components/redux/Actions/MuseumActions";
import { RemoveAccessToken } from "./components/redux/Actions/AccessTokenActions";
// import { useHistory } from "react-router-dom";
// import * as serviceWorker from '../public/worker';

// Add a request interceptor
axios.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const access_token = state.AccessTokenData.accessToken;
    const token = "Bearer " + access_token + "";
    config.headers.Authorization = token;
    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401 || error.response.status === 403) {
      store.dispatch(RemoveAccessToken());
      store.dispatch(RemoveUser());
      store.dispatch(RemoveMuseum());
    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

// serviceWorker.register();

reportWebVitals();
